import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-66c38997"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sensitive-file-list-tip-tooltip" }
const _hoisted_2 = { class: "sensitive-file-list-tip-tooltip__title" }
const _hoisted_3 = { class: "sensitive-file-list-tip-tooltip__list" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont cm-icon-info sensitive-file-list-tip-trigger",
  "aria-hidden": "true"
}, null, -1))

import { ref, reactive, computed, onMounted, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import dayjs from 'dayjs'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { PermissionFe, ServicePermissionService } from '@/services/service-permission.service'
import PageSubscribeBar from '@/views/dashboard/_components/subscribe-bar/page-subscribe-bar.vue'
import StatisticsCards from './_components/statistics-cards.vue'
import PlainStatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import PendingApprovalList from '@/views/dashboard/_components/pending-approval-list/pending-approval-list.vue'
import OutboundCountRankingChart from './_components/outbound-count-ranking-chart.vue'
import OutboundTypeChart from './_components/outbound-type-chart.vue'
import OutboundControlLogList from '@/views/dashboard/manage/outbound-control-log/_components/outbound-control-log-list/outbound-control-log-list.vue'
import SensitiveFileListSection from './_components/sensitive-file-list-section.vue'
import Card from '@/views/dashboard/_components/card/card.vue'
import { TableViewMode } from '@/views/dashboard/_enum/table-view-mode'
import PolicyManage from '@/views/dashboard/_components/policy-manage/policy-manage.vue'
import { PolicyCommonService, StrategyListDataCommon } from '@/views/dashboard/policy/policy-common.service'
import { PolicySettingType, PolicyType } from '@/views/dashboard/_enum/policy-type'
import { GroupRefreshManage } from '@/services/group'
import { TableOptColumn } from '@/components/cmTable/types'
import StrategySetting from './components/strategy-setting.vue'
import { SensitiveService } from './service'
import { behaviorStateI18nKey } from './types/approval-terminal-file-outsourcing'
import { ApprovalListService } from '@/views/dashboard/approval-center/service'
import { ApiApprovalTypeEnum, ApiApprovalStatusEnum, ApprovalListDataItem } from '@/views/dashboard/approval-center/types'
import { formatTimeStamp, getTimeRangeByEnum } from '@/utils/time'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'
import ExportDropdown from '../../_components/export-dropdown/export-dropdown.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'sensitive-file-scanning',
  setup(__props) {

const router = useRouter()

const injector = useReflectiveInjector([PolicyCommonService, SensitiveService, GroupRefreshManage, ApprovalListService])
const servicePermissionService = injector.get(ServicePermissionService)
const policyCommonService = injector.get(PolicyCommonService)
const groupRefreshManage = injector.get(GroupRefreshManage)
const sensitiveService = injector.get(SensitiveService)
const approvalListService = injector.get(ApprovalListService)
const hasPermission = servicePermissionService.getHasPermission(PermissionFe.dlp_control)

// 策略相关
const saveOrUpdatePolicyApi = policyCommonService.saveSettings.bind(policyCommonService)
const getPolicyApi = policyCommonService.getSettings.bind(policyCommonService)
const getSensitiveWordsListApi = sensitiveService.getSensitiveWordsList.bind(sensitiveService)
const sensitiveWordsChannelApi = sensitiveService.getSensitiveWordsChannel.bind(sensitiveService)

const policyManageRef = ref()
const selectedIds = ref<number[]>([])
const activeRow = ref({} as StrategyListDataCommon)
const visible = ref(false)
const fromGroupId = ref<number | undefined>()

const { t, locale } = useI18n()
const customCols = computed<TableOptColumn[]>(() => {
  void locale.value
  return [
    {
      label: t('sensitiveFileScanning.targetFile'),
      prop: 'main_switch',
      formatter: (_row) => {
        const k = behaviorStateI18nKey[_row.strategy.behavior as 1 | 2]
        return k ? t(k) : ''
      },
      columnOpt: { minWidth: 120 }
    },
  ]
})

function handlePolicyAction({ type, rowItem, ...other }: { type: string; rowItem?: StrategyListDataCommon;[key: string]: any }) {
  if (!policyManageRef.value) return
  const { validGroupId, selectedIds: policySelectedIds } = policyManageRef.value
  selectedIds.value = policySelectedIds || []

  const types: any = {
    add: () => {
      visible.value = true
      activeRow.value = {} as StrategyListDataCommon
      fromGroupId.value = validGroupId
    },
    edit: () => {
      visible.value = true
      activeRow.value = rowItem!
      fromGroupId.value = undefined
    },
    selfDelete: () => {
      // PolicyManage 内部已经处理了删除逻辑，这里不需要额外处理
    },
  }
  types?.[type]?.()
}
const sensitiveFileListSectionRef = ref()
const outboundControlLogListRef = ref<InstanceType<typeof OutboundControlLogList> | null>(null)
function handleCardExport(type: 0 | 1) {
  outboundControlLogListRef.value?.download(type)
}

function handlePolicyRefresh() {
  groupRefreshManage.refreshGroup()
  if (policyManageRef.value) {
    policyManageRef.value.tableRef.getList()
  }
}

// 统计数据
const statistics = reactive({
  todayOutboundCount: 0, // 今日外发文件次数(阻断+放行)
  blockedCount: 0, // 今日外发文件阻断次数
  pendingApprovalCount: 0 // 待审批申请
})

/** 日文专版顶部统计：与列表区默认筛选一致（预览 limit=10、Windows+Server） */
const jpOverview = reactive({
  discoveredSensitiveFileCount: 0,
  configuredSensitiveWordCount: 0,
})

const jpStatisticsCardItems = computed(() => {
  void locale.value
  const can = hasPermission
  return [
    {
      label: t('sensitiveFileScanning.jpStatDiscoveredSensitiveFiles'),
      value: jpOverview.discoveredSensitiveFileCount,
      span: 12,
      clickable: can,
    },
    {
      label: t('sensitiveFileScanning.jpStatConfiguredSensitiveWords'),
      value: jpOverview.configuredSensitiveWordCount,
      span: 12,
      clickable: can,
    },
  ]
})

// 待办审批列表
const pendingApprovalList = ref<Array<{
  id: string
  description: string
  user: string
  time: string,
  [key: string]: any
}>>([])

// 图表数据
const rankingTimeRange = ref<TimeRange>(TimeRange.DAYS_30)
const rankingData = ref<
  Array<{
    name: string
    department: string
    count: number
    device_id?: string
    group_id?: string
  }>
>([])

const typeTimeRange = ref<TimeRange>(TimeRange.DAYS_30)
const typeData = ref<Array<{ name: string; value: number }>>([])

// 抽屉状态
const outboundLogDrawerVisible = ref(false)
const outboundLogDrawerListKey = ref(0)
const outboundLogDrawerInitialDateEmpty = ref(false)
const outboundLogDrawerInitialTimeRangeUnix = ref<[number, number] | undefined>(undefined)
const outboundLogDrawerInitialKeyword = ref<string | undefined>(undefined)
const outboundLogDrawerInitialGroupId = ref<string | undefined>(undefined)
/** 侧栏打开时按策略 id 筛选（与策略名称一一对应） */
const outboundLogDrawerInitialStrategyId = ref<string | undefined>(undefined)
/** 从策略「触发次数」打开侧栏时，标题展示策略名称 */
const outboundLogDrawerPolicyName = ref('')
const sensitiveFileDrawerVisible = ref(false)
const outboundCountRankingChartRef = ref()

// 处理审批
function handleApprove(item: any) {
  approvalListService.getApprovalApprove({
      approval_type: ApiApprovalTypeEnum.FileOutbound, // 文件外发类型
      record_id: item.id,
      is_agree: true
    }).then(() => {
      ElMessage.success(t('sensitiveFileScanning.operationSuccess'))
      // 重新加载待办审批列表
      loadPendingApprovalList()
      // 重新加载统计数据
      loadStatistics()
    }).catch(() => {
      ElMessage.error(t('sensitiveFileScanning.operationFailed'))
    })
}

// 处理驳回
function handleReject(item: any, reason?: string) {
  // 如果没有传入原因，弹出输入框
  if (!reason || !reason.trim()) {
    ElMessageBox.prompt(t('sensitiveFileScanning.inputRejectReason'), t('sensitiveFileScanning.tip'), {
      confirmButtonText: t('sensitiveFileScanning.confirm'),
      cancelButtonText: t('sensitiveFileScanning.cancel'),
      inputPlaceholder: t('sensitiveFileScanning.rejectReasonPlaceholder'),
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return t('sensitiveFileScanning.rejectReasonRequired')
        }
        return true
      }
    }).then(({ value }) => {
      // 用户输入了原因，继续处理
      approvalListService.getApprovalApprove({
        approval_type: ApiApprovalTypeEnum.FileOutbound, // 文件外发类型
        record_id: item.id,
        is_agree: false,
        reason: value.trim()
      }).then(() => {
        ElMessage.success(t('sensitiveFileScanning.operationSuccess'))
        loadPendingApprovalList()
        loadStatistics()
      }).catch(() => {
        ElMessage.error(t('sensitiveFileScanning.operationFailed'))
      })
    }).catch(() => {})
    return
  }

  // 如果已经有原因，直接处理
  approvalListService.getApprovalApprove({
    approval_type: ApiApprovalTypeEnum.FileOutbound, // 文件外发类型
    record_id: item.id,
    is_agree: false,
    reason: reason.trim()
  }).then(() => {
    ElMessage.success(t('sensitiveFileScanning.operationSuccess'))
    loadPendingApprovalList()
    loadStatistics()
  }).catch(() => {
    ElMessage.error(t('sensitiveFileScanning.operationFailed'))
  })
}

// 查看审批中心
function handleViewApprovalCenter() {
  router.push({
    path: '/dashboard/approval-center',
    query: {
      approvalType: '2' // 文件外发审批类型
    }
  })
}

// 查看全部外发管控日志
function viewAllOutboundLogs() {
  if (!hasPermission) return
  outboundLogDrawerInitialDateEmpty.value = false
  outboundLogDrawerInitialTimeRangeUnix.value = undefined
  outboundLogDrawerInitialKeyword.value = undefined
  outboundLogDrawerInitialGroupId.value = undefined
  outboundLogDrawerInitialStrategyId.value = undefined
  outboundLogDrawerPolicyName.value = ''
  outboundLogDrawerListKey.value += 1
  outboundLogDrawerVisible.value = true
}

/** 策略列表「触发次数」：打开外发管控日志侧栏，按当前策略 + 近 30 天查询 */
function handleClickTriggerTime(item: StrategyListDataCommon) {
  outboundLogDrawerInitialStrategyId.value = item.id
  outboundLogDrawerPolicyName.value = item.name || ''
  outboundLogDrawerInitialKeyword.value = undefined
  outboundLogDrawerInitialGroupId.value = undefined
  outboundLogDrawerInitialDateEmpty.value = false
  const [startSec, endSec] = getTimeRangeByEnum(TimeRange.DAYS_30)
  if (startSec !== undefined && endSec !== undefined) {
    outboundLogDrawerInitialTimeRangeUnix.value = [startSec, endSec]
  } else {
    outboundLogDrawerInitialDateEmpty.value = true
    outboundLogDrawerInitialTimeRangeUnix.value = undefined
  }
  outboundLogDrawerListKey.value += 1
  outboundLogDrawerVisible.value = true
}

/** 外发次数排行点击：全部时间不限制；否则与排行时间一致；关键字/分组与终端一致 */
function handleOutboundRankingRowClick(payload: {
  count: number
  chartTimeRange: TimeRange
  computerName: string
  groupId?: string
}) {
  if (payload.count <= 0) return
  outboundLogDrawerInitialStrategyId.value = undefined
  outboundLogDrawerPolicyName.value = ''
  outboundLogDrawerInitialKeyword.value = payload.computerName
  outboundLogDrawerInitialGroupId.value =
    payload.groupId !== undefined && payload.groupId !== '' ? payload.groupId : undefined
  if (payload.chartTimeRange === TimeRange.ALL) {
    outboundLogDrawerInitialDateEmpty.value = true
    outboundLogDrawerInitialTimeRangeUnix.value = undefined
  } else {
    outboundLogDrawerInitialDateEmpty.value = false
    const [startSec, endSec] = getTimeRangeByEnum(payload.chartTimeRange)
    if (startSec !== undefined && endSec !== undefined) {
      outboundLogDrawerInitialTimeRangeUnix.value = [startSec, endSec]
    } else {
      outboundLogDrawerInitialDateEmpty.value = true
      outboundLogDrawerInitialTimeRangeUnix.value = undefined
    }
  }
  outboundLogDrawerListKey.value += 1
  outboundLogDrawerVisible.value = true
}

// 查看全部敏感文件列表
function viewAllSensitiveFiles() {
  if (!hasPermission) return
  sensitiveFileDrawerVisible.value = true
}
/** 日文专版顶部统计卡：第一项 → 敏感文件全量抽屉；第二项 → 敏感词配置抽屉 */
function onJpStatisticsCardClick(index: number) {
  if (!hasPermission) return
  if (index === 0) {
    viewAllSensitiveFiles()
  } else if (index === 1) {
    sensitiveFileListSectionRef.value?.openScanningConfig?.()
  }
}

function onSensitiveFilePreviewTotal(count: number) {
  if (!IS_JP_ONLY_BUILD) return
  jpOverview.discoveredSensitiveFileCount = count
}

async function loadJpSensitiveOverviewStatistics() {
  if (!hasPermission) return
  try {
    /** 已发现敏感文件数由预览区 SensitiveFileListSection 的 file_view_count 经 @file-view-total 同步，避免重复请求 */
    const statRes = await sensitiveService.getSensitivewordsStat()
    jpOverview.configuredSensitiveWordCount = Number(statRes.keyword_count ?? 0) || 0
  } catch (error) {
    console.error('加载日文专版统计数据失败:', error)
  }
}

// 加载统计数据
async function loadStatistics() {
  if (!hasPermission) return
  if (IS_JP_ONLY_BUILD) {
    await loadJpSensitiveOverviewStatistics()
    return
  }
  try {
    const res = await sensitiveService.getSensitivefilesendStatistics()
    statistics.todayOutboundCount = res.today_send_count || 0
    statistics.blockedCount = res.today_block_count || 0
    // pendingApprovalCount 由 loadPendingApprovalList 更新
  } catch (error) {
    console.error('加载统计数据失败:', error)
  }
}

// 加载图表数据
async function loadChartData() {
  if (!hasPermission) return
  try {
    // 加载类型图表数据
    await loadTypeChartData()
    // 加载排行图表数据
    await loadRankingChartData()
  } catch (error) {
    console.error('加载图表数据失败:', error)
  }
}

// 加载排行图表数据（敏感词终端 TOP，与 /sensitivewords/terminal_top 一致）
async function loadRankingChartData() {
  if (!hasPermission) return
  if (outboundCountRankingChartRef.value) {
    outboundCountRankingChartRef.value.loading = true
  }
  try {
    const [start_time, end_time] = getTimeRangeByEnum(rankingTimeRange.value)
    const params: { limit: number; start_time?: string; end_time?: string } = { limit: 5 }
    if (start_time !== undefined && end_time !== undefined) {
      params.start_time = start_time.toString()
      params.end_time = end_time.toString()
    }

    const res = await sensitiveService.getSensitivewordsTerminalTop(params)

    rankingData.value = (res.data || []).map((item) => ({
      name: item.computer_name || t('sensitiveFileScanning.unknown'),
      department: item.group_name || t('sensitiveFileScanning.unknown'),
      count: item.outgoing_count ?? 0,
      device_id: item.device_id,
      group_id: item.group_id,
    }))
  } catch (error) {
    console.error('加载排行图表数据失败:', error)
    rankingData.value = []
  } finally {
    if (outboundCountRankingChartRef.value) {
      outboundCountRankingChartRef.value.loading = false
    }
  }
}

// 加载类型图表数据
async function loadTypeChartData() {
  if (!hasPermission) return
  try {
    const [start_time, end_time] = getTimeRangeByEnum(typeTimeRange.value)

    if (start_time === undefined || end_time === undefined) {
      typeData.value = []
      return
    }

    const res = await sensitiveService.getSensitivefilesendKeywordTypeCountTop({
      start_time: start_time.toString(),
      end_time: end_time.toString(),
      limit: 10
    })

    if (res.data && res.data.length > 0) {
      typeData.value = res.data.map(item => ({
        name: item.name,
        value: item.send_count
      }))
    } else {
      typeData.value = []
    }
  } catch (error) {
    console.error('加载类型图表数据失败:', error)
    typeData.value = []
  }
}

// 加载待办审批列表
async function loadPendingApprovalList() {
  if (!hasPermission) return
  try {
    const res = await approvalListService.getApprovalList({
      approval_type: ApiApprovalTypeEnum.FileOutbound, // 文件外发类型
      page_no: 1,
      page_size: 5, // 只查询5条
      approval_status: ApiApprovalStatusEnum.Pending // 待审批状态
    })

    // 转换数据格式
    pendingApprovalList.value = (res.data || []).slice(0, 5).map((item: ApprovalListDataItem) => {
      let extInfo: any = {}
      try {
        extInfo = item.ext_info ? (typeof item.ext_info === 'string' ? JSON.parse(item.ext_info) : item.ext_info) : {}
      } catch (e) {
        console.error('解析 ext_info 失败:', e)
      }

      const userMark = extInfo.user_mark || extInfo.userMark || item.applicant || ''
      return {
        id: item.id,
        description: item.content,
        time: formatTimeStamp(parseInt(item.apply_time) * 1000, 'YYYY-MM-DD HH:mm'),
        user:item.applicant,
        ...item,
      }
    })

    // 更新统计数量
    statistics.pendingApprovalCount = parseInt(res.total || '0')
  } catch (error) {
    console.error('加载待办审批列表失败:', error)
  }
}

// 监听时间范围变化
watch(typeTimeRange, () => {
  loadTypeChartData()
})

watch(rankingTimeRange, () => {
  loadRankingChartData()
})

onMounted(async () => {
  await nextTick()
  loadStatistics()
  loadChartData()
  if (!IS_JP_ONLY_BUILD) {
    loadPendingApprovalList()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageSubscribeBar, {
      "normal-permission-key": _unref(PermissionFe).dlp_control
    }, null, 8, ["normal-permission-key"]),
    (!_unref(IS_JP_ONLY_BUILD))
      ? (_openBlock(), _createBlock(StatisticsCards, {
          key: 0,
          "today-outbound-count": statistics.todayOutboundCount,
          "blocked-count": statistics.blockedCount,
          "pending-approval-count": statistics.pendingApprovalCount
        }, null, 8, ["today-outbound-count", "blocked-count", "pending-approval-count"]))
      : (_openBlock(), _createBlock(PlainStatisticsCards, {
          key: 1,
          items: jpStatisticsCardItems.value,
          onItemClick: onJpStatisticsCardClick
        }, null, 8, ["items"])),
    (!_unref(IS_JP_ONLY_BUILD))
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 2,
          gutter: 16
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(PendingApprovalList, {
                  list: pendingApprovalList.value,
                  "data-type": 'file-outbound',
                  "show-confirm-dialog": false,
                  onApprove: handleApprove,
                  onReject: handleReject,
                  onViewMore: handleViewApprovalCenter
                }, null, 8, ["list"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(OutboundCountRankingChart, {
                  ref_key: "outboundCountRankingChartRef",
                  ref: outboundCountRankingChartRef,
                  "time-range": rankingTimeRange.value,
                  "onUpdate:timeRange": _cache[0] || (_cache[0] = ($event: any) => ((rankingTimeRange).value = $event)),
                  data: rankingData.value,
                  onRowClick: handleOutboundRankingRowClick
                }, null, 8, ["time-range", "data"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(OutboundTypeChart, {
                  "time-range": typeTimeRange.value,
                  "onUpdate:timeRange": _cache[1] || (_cache[1] = ($event: any) => ((typeTimeRange).value = $event)),
                  data: typeData.value
                }, null, 8, ["time-range", "data"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_unref(IS_JP_ONLY_BUILD))
      ? (_openBlock(), _createBlock(Card, {
          key: 3,
          size: "second",
          title: _ctx.$t('sensitiveFileScanning.fileOutboundEventTitle'),
          class: "cm-ui-mt16 cm-ui-mb16",
          onViewMore: viewAllOutboundLogs,
          "view-more-disabled": !_unref(hasPermission),
          "view-more-button-type": ""
        }, {
          titleAfter: _withCtx(() => [
            _createVNode(_component_el_tag, { size: "small" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
              ]),
              _: 1
            })
          ]),
          headerRight: _withCtx(() => [
            _createVNode(ExportDropdown, {
              "csv-i18n-key": "ransomwareIncident.exportCsv",
              "excel-i18n-key": "ransomwareIncident.exportExcel",
              "has-permission": _unref(hasPermission),
              onExport: handleCardExport
            }, null, 8, ["has-permission"])
          ]),
          default: _withCtx(() => [
            _createVNode(OutboundControlLogList, {
              ref_key: "outboundControlLogListRef",
              ref: outboundControlLogListRef,
              "view-mode": _unref(TableViewMode).preview,
              "has-permission": _unref(hasPermission)
            }, null, 8, ["view-mode", "has-permission"])
          ]),
          _: 1
        }, 8, ["title", "view-more-disabled"]))
      : _createCommentVNode("", true),
    _createVNode(Card, {
      size: "second",
      title: _ctx.$t('sensitiveFileScanning.sensitiveFileListTop10'),
      class: _normalizeClass(_unref(IS_JP_ONLY_BUILD) ? '' : 'cm-ui-mt16 cm-ui-mb16'),
      style: _normalizeStyle(!_unref(IS_JP_ONLY_BUILD) ? '' : 'height: 100%;'),
      "view-more-button-type": ""
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tooltip, {
          placement: "bottom-start",
          effect: "light",
          "show-after": 200,
          "popper-class": "sensitive-file-list-tip-popper"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('sensitiveFileScanning.sensitiveFileListCardTipTitle')), 1),
              _createElementVNode("ol", _hoisted_3, [
                _createElementVNode("li", null, _toDisplayString(_ctx.$t('sensitiveFileScanning.sensitiveFileListCardTip1')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$t('sensitiveFileScanning.sensitiveFileListCardTip2')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$t('sensitiveFileScanning.sensitiveFileListCardTip3')), 1)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(SensitiveFileListSection, {
          ref_key: "sensitiveFileListSectionRef",
          ref: sensitiveFileListSectionRef,
          "view-mode": _unref(TableViewMode).preview,
          "has-permission": _unref(hasPermission),
          onViewAll: viewAllSensitiveFiles,
          onFileViewTotal: onSensitiveFilePreviewTotal
        }, null, 8, ["view-mode", "has-permission"])
      ]),
      _: 1
    }, 8, ["title", "class", "style"]),
    (!_unref(IS_JP_ONLY_BUILD))
      ? (_openBlock(), _createBlock(PolicyManage, {
          key: 4,
          ref_key: "policyManageRef",
          ref: policyManageRef,
          title: _ctx.$t('sensitiveFileScanning.policyList'),
          "normal-permission-key": _unref(PermissionFe).dlp_control,
          "strategy-type": _unref(PolicyType).dlp_control_type,
          "data-type": _unref(PolicySettingType).dlp_control_type_setting_type,
          "custom-cols": customCols.value,
          "hide-tabs": true,
          triggerTimeCallback: handleClickTriggerTime,
          onHandleAction: handlePolicyAction,
          class: "cm-ui-mt16"
        }, null, 8, ["title", "normal-permission-key", "strategy-type", "data-type", "custom-cols"]))
      : _createCommentVNode("", true),
    (!_unref(IS_JP_ONLY_BUILD))
      ? (_openBlock(), _createBlock(_component_el_drawer, {
          key: 5,
          size: "75%",
          title: _ctx.$t('sensitiveFileScanning.strategySetting'),
          modelValue: visible.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
          "destroy-on-close": ""
        }, {
          default: _withCtx(() => [
            _createVNode(StrategySetting, {
              modelValue: visible.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
              onRefresh: handlePolicyRefresh,
              needToNav: false,
              api: { getApi: _unref(getPolicyApi), saveOrUpdateApi: _unref(saveOrUpdatePolicyApi), listApi: _unref(getSensitiveWordsListApi), sensitiveWordsChannelApi: _unref(sensitiveWordsChannelApi) },
              id: activeRow.value.id,
              "from-group-id": fromGroupId.value
            }, null, 8, ["modelValue", "api", "id", "from-group-id"])
          ]),
          _: 1
        }, 8, ["title", "modelValue"]))
      : _createCommentVNode("", true),
    (!_unref(IS_JP_ONLY_BUILD))
      ? (_openBlock(), _createBlock(_component_el_drawer, {
          key: 6,
          size: "80%",
          title: outboundLogDrawerPolicyName.value ? `${_ctx.$t('sensitiveFileScanning.allFileOutboundEvent')}（${outboundLogDrawerPolicyName.value}）` : _ctx.$t('sensitiveFileScanning.allFileOutboundEvent'),
          modelValue: outboundLogDrawerVisible.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((outboundLogDrawerVisible).value = $event)),
          "destroy-on-close": ""
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(OutboundControlLogList, {
              key: outboundLogDrawerListKey.value,
              "view-mode": _unref(TableViewMode).full,
              "has-permission": _unref(hasPermission),
              "initial-date-empty": outboundLogDrawerInitialDateEmpty.value,
              "initial-time-range-unix": outboundLogDrawerInitialTimeRangeUnix.value,
              "initial-keyword": outboundLogDrawerInitialKeyword.value,
              "initial-group-id": outboundLogDrawerInitialGroupId.value,
              "initial-strategy-id": outboundLogDrawerInitialStrategyId.value,
              style: {"padding":"16px 16px 0"}
            }, null, 8, ["view-mode", "has-permission", "initial-date-empty", "initial-time-range-unix", "initial-keyword", "initial-group-id", "initial-strategy-id"]))
          ]),
          _: 1
        }, 8, ["title", "modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_drawer, {
      size: "80%",
      title: _ctx.$t('sensitiveFileScanning.allSensitiveFileList'),
      modelValue: sensitiveFileDrawerVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((sensitiveFileDrawerVisible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(SensitiveFileListSection, {
          "view-mode": _unref(TableViewMode).full,
          "has-permission": _unref(hasPermission),
          style: {"padding":"16px 16px 0"}
        }, null, 8, ["view-mode", "has-permission"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ], 64))
}
}

})